import { render, staticRenderFns } from "./LinkWithApis.vue?vue&type=template&id=67c3cd33"
import script from "./LinkWithApis.vue?vue&type=script&lang=js"
export * from "./LinkWithApis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports